// extracted by mini-css-extract-plugin
export default {"link":"dR5ID5SKLKTSeWXxVegg","active":"U00_09EMFiKxNGlqO3Mg","placeHolderShimmer":"CeOPZHs1rjPD7Y5F82ZY"};